import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import React from 'react';

import { useMenu } from 'hooks';
import { ellipsis, properCase } from 'lib/utils';

const RewardItem = ({
	reward,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(reward, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(reward, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(reward.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(reward)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(reward)}
						name="reward"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Typography variant="primary.text">{reward.title}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{ellipsis(reward.description, 50)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{reward.points}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{properCase(reward.status)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{reward.created_at}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default RewardItem;
